import OperationalPaymentConceptsView from '../OperationalPaymentConceptsView.vue'
import OperationalPaymentConceptList from '../Pages/OperationalPaymentConceptList.vue'
import OperationalPaymentConceptEditor from '../Pages/OperationalPaymentConceptEditor.vue'

const routes = [
  {
    path: '/mantenimiento/conceptos-pago-operativo',
    component: OperationalPaymentConceptsView,
    children: [
      { path: '', name: 'operational-payment-concept-list', component: OperationalPaymentConceptList },
      { path: 'crear', name: 'operational-payment-concept-create', component: OperationalPaymentConceptEditor },
      { path: ':id', name: 'operational-payment-concept-edit', component: OperationalPaymentConceptEditor },
    ],
  },
]

export default routes
